import React, { useEffect, useLayoutEffect, useState, useRef } from 'react'

import { getAllRedirections } from '../../api/getapi'
import { addRedirection, deleteRedirection, updateRedirection } from '../../api/postapi'
import CustomizeTableview from '../TableView/CustomizeTableview'
import { toast } from 'react-toastify'
import PaginationBar from '../PaginationBar/PaginationBar'
import { Form, InputGroup, Button, Modal } from 'react-bootstrap'


const ViewRedirections = () => {

  const [data,setData]=useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [searchQuery, setSearchQuery] = useState('')
  const [totalCount, setTotalCount] = useState(0)
  const rowsPerPage = 10
  const isSearchChanging = useRef(false)
  const prevPage = useRef(1)
  const [showModal, setShowModal] = useState(false)
  const [redirectForm, setRedirectForm] = useState({ old_url: '', new_url: '' })
  const [editingRedirection, setEditingRedirection] = useState(null)


  const fetchRedirections=async (page = currentPage, search = searchQuery)=>{
    await getAllRedirections(page, rowsPerPage, search).then(res=>{
      const responseData = res?.data?.data || [];
      const total = res?.data?.pagination?.no_of_items || responseData.length;
      
      setTotalCount(total);

      
      setData(responseData)
    }).catch(e=>console.log(e));
    
  }


  // Initial load
  useLayoutEffect(()=>{
    fetchRedirections(1, '')
  },[])

  // Debounced search effect
  useEffect(() => {
    isSearchChanging.current = true;
    
    const delayDebounce = setTimeout(() => {
      setCurrentPage(1); // Reset to first page on new search
      prevPage.current = 1; // Update prev page
      fetchRedirections(1, searchQuery);
      isSearchChanging.current = false;
    }, 500);

    return () => {
      clearTimeout(delayDebounce);
      isSearchChanging.current = false;
    };
  }, [searchQuery])

  // Fetch data when page changes
  useEffect(() => {
    // Only fetch if page actually changed and search is not changing
    if (!isSearchChanging.current && prevPage.current !== currentPage) {
      fetchRedirections(currentPage, searchQuery);
      prevPage.current = currentPage;
    }
  }, [currentPage])


  const edit=(row)=>{
    setEditingRedirection(row)
    setRedirectForm({
      old_url: row?.url || '',
      new_url: row?.redirect_url || ''
    })
    setShowModal(true)
  }

  const remove=async (row)=>{
    try {
      await deleteRedirection(row.id)
      console.log('Redirection deleted successfully')
      toast.success('Redirection deleted successfully')
      // Refresh the data after deletion
      fetchRedirections(currentPage, searchQuery)
    } catch (e) {
      console.error('Error deleting redirection:', e)
      toast.error('Error deleting redirection')
    }
  }

  const handleActiveDeactive = async (row) => {
    try {
      const newStatus = !row.is_active;
      const submitData = {
        redirection: {
          is_active: newStatus
        }
      };
      
      await updateRedirection(row.id, submitData);
      toast.success(`Redirection ${newStatus ? 'activated' : 'deactivated'} successfully`);
      // Refresh the data after update
      fetchRedirections(currentPage, searchQuery);
    } catch (error) {
      console.error('Error updating Redirection status:', error);
      toast.error('Error updating Redirection status');
    }
  }

  const activeDeactiveConfig = {
    className: "w-100",
    style: {},
    variant: (row) => !row.is_active ? "success" : "danger",
    onClick: handleActiveDeactive,
    label: (row) => !row.is_active ? "Active" : "Inactive"
  };

  // Pagination calculations
  const totalPages = Math.ceil(totalCount / rowsPerPage)

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const openAddModal = () => {
    setEditingRedirection(null)
    setRedirectForm({ old_url: '', new_url: '' })
    setShowModal(true)
  }

  const closeModal = () => setShowModal(false)

  const handleRedirectInputChange = (e) => {
    const { name, value } = e.target
    setRedirectForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSaveRedirect=async()=>{
    const payload = {url:redirectForm.old_url,redirect_url:redirectForm.new_url}
    try{
        console.log(redirectForm);
        if(editingRedirection){
          await updateRedirection(editingRedirection.id,payload).then(res=>{
              console.log(res)
              toast.success('Redirect updated successfully')
              closeModal()
              fetchRedirections(currentPage, searchQuery)
          }).catch(e=>{
              console.log(e)
              toast.error('Error updating redirect')
          })
        }else{
          await addRedirection(payload).then(res=>{
              console.log(res)
              toast.success('Redirect added successfully')
              closeModal()
              fetchRedirections(currentPage, searchQuery)
          }).catch(e=>{
              console.log(e)
              toast.error('Error adding redirect')
          })
        }
    }catch(e){
        console.log(e)
    }
  }

  return (
  <>
  {/* Search Bar + Add Redirect */}
  <div className="mb-3 px-3 d-flex flex-column flex-md-row gap-2 align-items-stretch align-items-md-center justify-content-between">
    <InputGroup className="w-25"  >
      <Form.Control
        type="text"
        placeholder="Search by title..."
        value={searchQuery}
        onChange={handleSearchChange}
      />
    </InputGroup>
    <Button variant="primary" onClick={openAddModal}>
      Add Redirect
    </Button>
  </div>

  <CustomizeTableview 
    key={data?.id} 
    data={data} 
    ActiveDeactive={activeDeactiveConfig}
    edit={edit} 
    remove={remove} 
    columnNotShow={["id","is_active","created_at","updated_at","is_deleted"]}
  /> 

  {/* Pagination Controls */}
  {totalPages > 1 && (
    <div className="mt-3">
      <PaginationBar 
        noOfPages={totalPages}
        currentPage={currentPage}
        changePage={handlePageChange}
      />
    </div>
  )}

  {/* Add/Edit Redirect Modal */}
  <Modal show={showModal} onHide={closeModal} centered>
    <Modal.Header closeButton>
      <Modal.Title>{editingRedirection ? 'Edit Redirect' : 'Add Redirect'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form>
        <Form.Group className="mb-3" controlId="oldUrl">
          <Form.Label>Old URL</Form.Label>
          <Form.Control
            type="url"
            placeholder="https://old.example.com/path"
            name="old_url"
            value={redirectForm.old_url}
            onChange={handleRedirectInputChange}
          />
        </Form.Group>
        <Form.Group controlId="newUrl">
          <Form.Label>New URL</Form.Label>
          <Form.Control
            type="url"
            placeholder="https://new.example.com/path"
            name="new_url"
            value={redirectForm.new_url}
            onChange={handleRedirectInputChange}
          />
        </Form.Group>
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={closeModal}>
        Cancel
      </Button>
      <Button onClick={handleSaveRedirect} variant="primary" disabled={!redirectForm.old_url || !redirectForm.new_url}>
        {editingRedirection ? 'Update Redirect' : 'Save Redirect'}
      </Button>
    </Modal.Footer>
  </Modal>
  </>
  )
}

export default ViewRedirections
